import React, { useState } from 'react';
import { Button } from 'antd';
import { ChainSelector, DEFAULT_CHAIN_CONFIG, HOT_CHAIN_LIST } from '@fu2025831/react-kit';
import { useTranslation } from 'react-i18next';
import { cdnUrl } from '@/utils/cdn';
import "./index.less"
import MyIcon from '@/router/Icon';
export function FuPrivider({ controlOpen = false, setControlOpen }) {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation()
  const [currentChain, setCurrentChain] = useState('sui');
  const [locale, setLocale] = useState('zh-cn');

  const handleChainChange = (chain: ChainConfig) => {
    console.log('链切换:', chain);
    setCurrentChain(chain.key);

    // 如果链有 deployUrl，会在组件内部自动打开新窗口
    // 否则会触发 onChainChange 回调
  };

  return (
    <div>
      <Button onClick={() => { setOpen(true); setControlOpen(true) }}>
        {
          <div className='fu-btn'>
            <MyIcon style={{ fontSize: 18 }} type='icon-a-sui1'></MyIcon>
            <span>SUI</span>
            <img src="https://sui.slerf.tools/img/eth/up-outlined.webp" alt="" />
          </div>

        }
      </Button>

      <ChainSelector
        open={open || controlOpen}
        onClose={() => { setOpen(false); setControlOpen(false) }}
        chains={DEFAULT_CHAIN_CONFIG}  // 可选，不传则使用默认
        currentChain={currentChain}
        onChainChange={handleChainChange}
        locale={i18n.language || 'zh-cn'}
        activeColor="#1890ff"  // 自定义激活颜色
        hotChainSort={HOT_CHAIN_LIST}  // 可选，不传则使用默认
        width={560}  // 可选，默认 560
        className="custom-chain-selector"  // 可选，自定义类名
      />
    </div>
  );
}

